<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/A35tAz/tc-custom/9781685502164.jpg?1723406212935" alt="This image is the cover for the book Let Me Count the Flowers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Let Me Count the Flowers
      </h1>
      <p class="bookDescription body article font2">
        <p>Ever since earning his accounting degree, Cody McIntyre has bounced from temp job to temp job. For almost a year now, he's been the receptionist at Coffee Brew Distributions, and his contract with them expires in exactly twelve days. Hoping to stay with the company, Cody has interviewed for a permanent position that's recently become available. If he gets it, not only will it save him the aggravation of having to find a new job, but he'll get to keep working with his awesome coworkers, especially fun, easy-going, and attractive Shane Wilson.<br/><br/>But when someone starts leaving flowers with special meanings on his desk every morning, Cody doesn't know what to think, and can't even begin to speculate who they're from. Considering how hard he's been crushing on Shane, he can only hope he gets good news sometime in the next twelve days, bright and beautiful as all the lovely flowers.<br/><br/>Will Cody find out who his secret admirer is? Or will he have to leave the company without solving the mystery?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        K.S. Murphy
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?593b9dd0